import { TabStyles } from '@tableau/widgets';

export class Normalizer {

  private n: number;
  private max: number;

  public constructor(
    values: ReadonlyArray<number> = [],
    private width: number = 0,
    private height: number = 0,
    private originX: number = 0,
    private originY: number = 0) {
    this.n = values.length - 1;
    this.max = Math.max(...values);
  }

  public y(value: number) {
    // Because SVG's y axis starts with 0 at the top and increases downward, the normalization
    // also inverts the numbers on the axis so lower numbers appear lower on the screen.
    const y = (this.max <= 0) ? this.height : (this.max - value) * this.height / this.max;
    return y + this.originY;
  }

  public x(i: number) {
    const x = (this.n === 0) ? this.width : i * this.width / this.n;
    return x + this.originX;
  }
}

export class PathBuilder {

  public constructor(private normalize: Normalizer) { }

  // turns the values into a command readable by the path element
  private buildMovement(name: string, x: number, y: number): string {
    return `${name}${x},${y}`;
  }

  // creates a combined string of commands to be sent to a path element in the style created in buildMovement
  public buildPath(dataPoints: ReadonlyArray<number>): string {
    return dataPoints.reduce((movements: string, currentValue: number, index: number): string => {
      // The (i === 0) check is to move to the start of the path ('M'), otherwise it is
      // creating a line from the previous to the current point ('L').
      const moveType = (index === 0) ? 'M' : 'L';
      const x = this.normalize.x(index);
      const y = this.normalize.y(currentValue);
      return movements + this.buildMovement(moveType, x, y);
    }, '');
  }
}

// Exported for the unit tests
export class OffsetCorrector {
  private boundRect: ClientRect;
  public constructor(element: Element) {
    this.boundRect = element.getBoundingClientRect();
  }

  public correctHorizontalOffset(element: Element): number {
    const elementRect = element.getBoundingClientRect();
    const textBuffer = TabStyles.Spacing.SmallSpace;
    const rightOverreach = elementRect.right - (this.boundRect.right - textBuffer);
    const leftOverreach = (this.boundRect.left + textBuffer) - elementRect.left;

    let n = 0;
    let totalCorrection = 0;
    if (rightOverreach > 0) {
      totalCorrection -= rightOverreach;
      n++;
    }
    if (leftOverreach > 0) {
      totalCorrection += leftOverreach;
      n++;
    }

    // Average the two corrections
    return n === 0 ? 0 : (totalCorrection / n);
  }
}
